import { render } from "./Gifts.vue?vue&type=template&id=a8e08d00"
import script from "./Gifts.vue?vue&type=script&lang=js"
export * from "./Gifts.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__